import React, {useState} from 'react';
import './DashboardYourServices.scss';
import {Link} from 'react-router-dom';
import {useTranslation} from "react-i18next";
import {Tabs, Tab, Card} from 'react-bootstrap';

const handleClick = (route) => {
    window.location.href = route;
  };

const DashboardServiceList = (props) => {
  return (
    <div className="cards">
      {
        props.services && props.services.map(service => (
          <div className="grid-element" key={service.title}>
            <Link to={service.link} className="service-card-container">
              <Card className="service-card">
                <span className="service-text">{service.title}</span>
                <i className="gc-icon-functional-arrow-right"></i>
              </Card>
            </Link>
          </div>
        ))
      }
    </div>
  )
}

const DashboardYourServices = (props) => {
  const {services} = props;
  const [key, setKey] = useState(services[0].tab);
  const {t} = useTranslation();


  return (
    <section className="DashboardYourServices section-tab" data-testid="DashboardYourServices">
      <div className="container service-section-container">
        <h2 className="headline-bold-fs2">{t("dashboard.services.title2")}</h2>
          <div className="service-section">
            {
              services.length > 0 && services.map(service => {
                return (
                  <div
                    key={service.tab}  className="service-row">
                    <h5 className="headline-bold-fs5 service-section-title">{service.tabName}</h5>
                    <DashboardServiceList services={service.services} />
                  </div>
                )
              })
            }
          </div>
      </div>
    </section>
  )
};

DashboardYourServices.propTypes = {};

export default DashboardYourServices;
